<template>
<div id="lob">
  <template v-if="!showRoute">
    <component :is="currentView" />
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Loading lob information...
          <v-progress-linear indeterminate color="white" class="mb-0" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </template>
  <template v-else>
    <router-view />
  </template>
</div>
</template>

<style>
</style>

<script>
import { mapState, mapActions } from 'vuex';
import LineOfBusinessViewTabs from '@/views/clientViewer/LineOfBusiness/LineOfBusinessViewTabs.vue';
import lobCodeService from '@/services/clientViewer/lobCodeService.js';

export default {
  components: {
    LineOfBusinessViewTabs
  },
  data: function () {
    return {
      loading: false,
      showRoute: false,
      lobRouteNames: [
        'vehicle',
        'driver'
      ]
    };
  },
  computed: {
    ...mapState(['client']),
    clientId: function () {
      return this.$route.params.clientId;
    },
    currentView: function () {
      return 'LineOfBusinessViewTabs';
    },
    policyOrderNumber: function () {
      return this.$route.params.policyOrderNumber;
    },
    lobCode: function () {
      return this.$route.params.lobId;
    }
  },
  watch: {
    $route: {
      handler (to, from) {
        this.showRoute = this.lobRouteNames.indexOf(to.name) >= 0;
      },
      deep: true
    }
  },
  created: async function () {
    this.showRoute = this.lobRouteNames.indexOf(this.$route.name) >= 0;

    var lobCodeAsInt = this.lobCode == null ? 0 : parseInt(this.lobCode);
    if (isNaN(lobCodeAsInt)) lobCodeAsInt = 0;

    this.setSelectedLineOfBusinessCode(lobCodeAsInt);
    this.setLobName(lobCodeService.lobCodes[lobCodeAsInt]);
  },
  destroyed: function () {
    this.setSelectedLineOfBusinessCode(null);
    this.setLobName(null);
  },
  methods: {
    ...mapActions(['setError', 'setActivePolicyTab', 'setLobName', 'setSelectedLineOfBusinessCode'])
  }
};
</script>
